var React = require('react');

function ToriiGate (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M64 192h64v-64H64zm160 0h64v-64h-64zM64 496a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V256H64zm320 0a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V256h-64zm0-368v64h64v-64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M376.45 32h-240.9A303.17 303.17 0 0 1 0 0v96a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V0a303.17 303.17 0 0 1-135.55 32zM496 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z","className":"fa-primary","key":2})]);
}

ToriiGate.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = ToriiGate;

ToriiGate.default = ToriiGate;
